module.exports = __webpack_public_path__ + "static/media/hp-1-b-91-a-997-c-3-b-058-f-47-c-6-a-386-f-573-cd-1-da-1-f-3-a-9-fe-2.cb7867a2.png";